/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React from 'react';
import Input, { AmountInput, AccountInput, Select, SelectItem, PhoneInput } from 'ui/Input';
import FieldsLeveler from 'ui/structure/FieldsLeveler/FieldsLeveler';
import { onlyNCharacters } from 'utils/formatters';
import countries from './countries.json';
import { currencies, feesToBePaidBy, FormType, IFormValues, IFXState, transferTypes } from './FxTransferRequest.model';

const DEFAULT_COUNTRY_CODE = 'GH';
const DEFAULT_COUNTRY_NAME = 'Ghana';

const renderFields = ({ accounts, banks }: IFXState, values: IFormValues, form: FormType, submitting: boolean) => {
  const isLocal = values.transferType === 'Local Transfer';

  const onSelectType = ({ target }) => {
    form.mutators.changeFieldValue(target?.name, target?.value); // Override default handleChange()
    if (target?.value === 'Local Transfer') {
      form.mutators.changeFieldValue('beneficiaryCountry', DEFAULT_COUNTRY_NAME);
      form.mutators.changeFieldValue('beneficiaryBankName', '');
    }
  };

  return (
    <>
      <FieldsLeveler label="Transfer details" dividerBottom>
        <Select
          name="transferType"
          label="Transfer Type"
          disabled={submitting}
          SelectProps={{
            onChange: onSelectType,
          }}
        >
          {transferTypes.map((name) => (
            <SelectItem value={name} key={name}>
              {name}
            </SelectItem>
          ))}
        </Select>
        <Select name="currency" label="Transaction Currency" disabled={submitting}>
          {currencies.map((name) => (
            <SelectItem value={name} key={name}>
              {name}
            </SelectItem>
          ))}
        </Select>
        <Select name="sourceAccount" label="Account to Debit" disabled={submitting}>
          {accounts.map(({ accountNumber }) => (
            <SelectItem value={accountNumber} key={accountNumber}>
              {accountNumber}
            </SelectItem>
          ))}
        </Select>
        <AmountInput
          name="amount"
          label="Amount"
          currency={values.currency}
          disabled={!values.currency || submitting}
        />
      </FieldsLeveler>
      <FieldsLeveler label="Beneficiary details" dividerBottom>
        <Input name="beneficiaryName" label="Beneficiary Name" disabled={submitting} />
        <AccountInput name="beneficiaryAccount" label="Beneficiary Account" disabled={submitting} />
        <Select name="beneficiaryCountry" label="Beneficiary Country" disabled={submitting || isLocal}>
          {isLocal && <SelectItem value={DEFAULT_COUNTRY_CODE}>{DEFAULT_COUNTRY_NAME}</SelectItem>}
          {!isLocal &&
            countries.map(({ name, code }) => (
              <SelectItem value={code} key={code}>
                {name}
              </SelectItem>
            ))}
        </Select>
        {isLocal ? (
          <Select name="beneficiaryBankName" label="Beneficiary Bank Name" disabled={submitting}>
            {banks.map(({ BankName }) => (
              <SelectItem key={BankName} value={BankName}>
                {BankName}
              </SelectItem>
            ))}
          </Select>
        ) : (
          <Input name="beneficiaryBankName" label="Beneficiary Bank Name" disabled={submitting} />
        )}
        <Input name="beneficiaryBankAddress" label="Beneficiary Bank Address" disabled={submitting} />
        <Input
          name="swiftCode"
          label="Swift Code"
          fieldProps={{
            parse: (value: string) => onlyNCharacters(11)(value),
          }}
          disabled={submitting}
        />
        <Input name="sortCode" label="Sort Code" disabled={submitting} />
        <Input name="routingNumber" label="Routing Number" disabled={submitting} optional />
        <PhoneInput name="senderTelNumber" label="Contact Phone Number" disabled={submitting} />
      </FieldsLeveler>
      <FieldsLeveler label="Additional details" dividerBottom>
        <Select name="feePaidBy" label="Fees to Be Paid By" disabled={submitting}>
          {feesToBePaidBy.map((name) => (
            <SelectItem value={name} key={name}>
              {name}
            </SelectItem>
          ))}
        </Select>
        {values.feePaidBy === 'Sender' && (
          <Select name="accountForCharges" label="Account for Fees" disabled={submitting}>
            {accounts.map(({ accountNumber }) => (
              <SelectItem value={accountNumber} key={accountNumber}>
                {accountNumber}
              </SelectItem>
            ))}
          </Select>
        )}
        <Input
          name="purpose"
          label="Purpose of Transfer"
          disabled={submitting}
          fieldProps={{
            parse: onlyNCharacters(25),
          }}
        />
      </FieldsLeveler>
    </>
  );
};

export default renderFields;
